import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { simplifyLogin } from 'utils/formatString';

import {
  I18n,
  Switch,
  TextInput,
  Button,
  Tooltip,
  UpdatingStatus,
  Heading,
  Link,
  TabsList,
  Tab,
} from 'components';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

class AssociateAccount extends PureComponent {
  isAddDisabled() {
    const {
      accountLinkingStatus,
      isPasswordAvailable,
      userPassword,
      userLogin,
    } = this.props;

    return !userLogin
           || (isPasswordAvailable && !userPassword)
           || accountLinkingStatus.isUpdating;
  }

  render() {
    const {
      onCreateLink,
      accountLinkingStatus,
      withPassword,
      isPasswordAvailable,
      userLogin,
      userPassword,
      togglePasswordAvailability,
      changeUserLogin,
      changeUserPassword,
      showOffer,
      userTypes,
      userType,
      changeUserType,
    } = this.props;

    return (
      <form
        onSubmit={(e) => {
          e.preventDefault();

          if (!this.isAddDisabled()) {
            onCreateLink({
              userLogin: simplifyLogin(userLogin),
              isPasswordAvailable,
              userPassword,
              userType,
            });
          }
        }}
      >
        <Heading level={1}>
          <I18n path="settings.numberManagement.associatingAccount.title" />
        </Heading>
        <div className={cx('content')}>
          {withPassword
            && (
            <Switch
              name="is-password-available"
              className={cx('isPasswordAvailable')}
              checked={isPasswordAvailable}
              onChange={togglePasswordAvailability}
              disabled={accountLinkingStatus.isUpdating}
            >
              <I18n path="settings.numberManagement.associatingAccount.passwordIsAvailable" />
            </Switch>
            )}
          <div>
            <div className={cx('inputLabel')}>
              <I18n path="settings.numberManagement.associatingAccount.userLoginLabel" />
              <Tooltip>
                <I18n path="settings.numberManagement.associatingAccount.loginHint" />
              </Tooltip>
            </div>
            <TextInput
              className={cx('textInput')}
              value={userLogin}
              onChange={changeUserLogin}
              disabled={accountLinkingStatus.isUpdating}
            />
          </div>
          {isPasswordAvailable
            && (
            <div className={cx('inputWrapper')}>
              <div className={cx('inputLabel')}>
                <I18n
                  path="settings.numberManagement.associatingAccount.userPasswordLabel"
                />
              </div>
              <div className={cx('passwordWrapper')}>
                <TextInput
                  type="password"
                  className={cx('passwordInput')}
                  value={userPassword}
                  onChange={changeUserPassword}
                  disabled={accountLinkingStatus.isUpdating}
                />
                <div className={cx('offerHint')}>
                  <I18n path="settings.numberManagement.associatingAccount.acceptOffer" />
                  &nbsp;
                  <Link
                    onClick={showOffer}
                  >
                    <I18n path="settings.numberManagement.associatingAccount.offerConditions" />
                  </Link>
                </div>
              </div>
            </div>
            )}
          {userTypes
            ? (
              <div>
                <span className={cx('userTypesDescription')}>
                  <I18n path="settings.numberManagement.associatingAccount.errorMessages.AMBIGUOUS_USER_TYPE" />
                </span>
                <TabsList
                  type="segmented"
                  className={cx('userTypes')}
                  activeTab={userType}
                  handleTabClick={changeUserType}
                >
                  {userTypes.map((type) => (
                    <Tab
                      id={type}
                      key={type}
                    >
                      <I18n path={`settings.numberManagement.associatingAccount.userTypes.${type}`} />
                    </Tab>
                  ))}
                </TabsList>
              </div>
            )
            : (
              <UpdatingStatus
                {...accountLinkingStatus}
                className={cx('updatingStatus')}
                successMessage="settings.numberManagement.associatingAccount.linkingSuccess"
                errorMessage={`settings.numberManagement.associatingAccount.errorMessages.${accountLinkingStatus.error}`}
              />
            )}
          <div className={cx('button')}>
            <Button
              type="submit"
              className="big"
              disabled={this.isAddDisabled()}
            >
              <I18n path="common.add" />
            </Button>
          </div>
        </div>
      </form>
    );
  }
}

AssociateAccount.propTypes = {
  onCreateLink: PropTypes.func,
  accountLinkingStatus: PropTypes.object,
  withPassword: PropTypes.bool,
  isPasswordAvailable: PropTypes.bool,
  userLogin: PropTypes.string,
  userPassword: PropTypes.string,
  userTypes: PropTypes.array,
  userType: PropTypes.string,
  togglePasswordAvailability: PropTypes.func,
  changeUserLogin: PropTypes.func,
  changeUserPassword: PropTypes.func,
  showOffer: PropTypes.func,
  changeUserType: PropTypes.func,
};

export default AssociateAccount;
